// creating all factories here in a separate file is needed to get tree-shaking working
import * as allFactories from '../factoriesAny.js';
export var all = allFactories;


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/allFactoriesAny.js
// module id = tonn
// module chunks = 3